/**
 * Renumbers the headings of rich-text content so the highest one becomes `topLevel` (the page
 * title is the H1), keeping their order: content written with only h3s becomes h2s, its h4s h3s.
 * Each moved heading keeps its original size through `data-heading-size` (see HTMLArticle).
 */
export const shiftHeadings = (html: string, topLevel = 2): string => {
  const levels = [...html.matchAll(/<h([1-6])\b/gi)].map((match) => Number(match[1]))

  if (!levels.length) {
    return html
  }

  const shift = topLevel - Math.min(...levels)

  if (!shift) {
    return html
  }

  return html.replace(
    /<(\/?)h([1-6])\b([^>]*)>/gi,
    (_tag, closing: string, level: string, attributes: string) => {
      const next = Math.min(6, Math.max(1, Number(level) + shift))

      return closing ? `</h${next}>` : `<h${next} data-heading-size="${level}"${attributes}>`
    }
  )
}
